module.exports = __webpack_public_path__ + "img/o1.35ec97bb.jpg";